<template>
  <div>
    <div v-if="validToken" class="box box-success">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t('pages.' + type + '.msg')}}</h3>
      </div>
      <form class="form-horizontal">
        <div class="box-body">
          <div class="form-group">
            <label for="inputPassword" class="col-sm-3 control-label">{{$t('pages.' + type + '.password')}}</label>
            <div class="col-sm-9">
              <input v-model="password" type="password" class="form-control" id="inputPassword" placeholder="">
            </div>
          </div>
          <div class="form-group">
            <label for="inputRetypePassword" class="col-sm-3 control-label">{{$t('pages.' + type + '.retypePassword')}}</label>
            <div class="col-sm-9">
              <input v-model="retypePassword" type="password" class="form-control" id="inputRetypePassword" placeholder="">
            </div>
          </div>
        </div>
        <div class="box-footer text-center">
          <button @click.prevent="submitData" type="submit" class="btn btn-success pull-right">{{$t('pages.' + type + '.confirmButtonMsg')}}</button>
          <p class="help-block">{{ statusMsg }}</p>
        </div>
      </form>
    </div>
    <div v-if="!validToken" class="help-block text-center">
      {{ statusMsg }}
    </div>
  </div>
</template>

<script>
  import router from './../../router/router'
  export default {
    data () {
      return {
        type: this.$route.meta.type,
        msg: '',
        password: '',
        retypePassword: '',
        validToken: true,
        statusMsg: ''
      }
    },
    created () {
      this.$store.dispatch('verifyToken', this.$route.params.token).then((data) => {
        this.validToken = true
      }).catch((err) => {
        this.statusMsg = err.responseJSON.message
      })
    },
    watch: {
      // whenever password changes, this function will run
      password (newPassword) {
        // this.msg = newPassword
      }
    },
    computed: {
      /*
      ...mapGetters({
        pictureBaseURL: 'pictureBaseURL',
        googleSignInParams: 'googleSignInParams'
      }),
      ...mapState({
        identifier: state => state.login.identifier,
        password: state => state.login.password,
        rememberMe: state => state.login.rememberMe,
        status: state => state.login.status,
        submited: state => state.login.submited,
        resetFormState: state => state.showResetForm
      })
      */
    },
    methods: {
      submitData () {
        if (this.password === this.retypePassword) {
          this.$store.dispatch('setPassword', {
            token: this.$route.params.token,
            password: this.password
          }).then((data) => {
            // Login
            // Redirect to homepage, login happens on backend
            // Not sure who started working on that, just added a display msg for now
            this.statusMsg = this.$t('pages.setPassword.successMsg')
            setTimeout(function () {
              router.push({name: `home`})
            }, 2000)
          }).catch((err) => {
            this.statusMsg = err.responseJSON.message
          })
        } else {
          this.statusMsg = this.$t('errors.mismatch')
        }
        /*
        this.$store.dispatch('login', { //
          identifier: this.identifier,
          password: this.password,
          rememberMe: this.rememberMe
        }, uporIme, pass).then(() => {
          console.log('here')
          console.log(Auth.getFromLocalStorage('language'))
          this.$store.dispatch('updateLanguage', Auth.getFromLocalStorage('language'))
          //router.push('/groupList')
        }).catch((err) => {
          console.log(err)
        })
        */
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SetPassword.vue?e0b671c4